import React from "react";
import { EWsrvTransform } from "../../lib/Media/util";
import { Carousel } from "../Carousel/Carousel";
import { ListingGallery } from "../Gallery/ListingGallery";
import ListingCard, { EListingCardLayouts } from "./ListingCard";
import { ListingContact } from "./ListingContact";
import ListingDetails from "./ListingDetails";
import ListingMap from "./ListingMap";
import { ListingSummary } from "./ListingSummary";
import { EListingVitalsLayout, ListingVitals } from "./ListingVitals";
import { IListingLayoutProps } from "./util";
import { ContactForm } from "../Forms";
import { ERateInterval, RentalVitals } from "./RentalVitals";
import { RentalCalendar } from "./RentalCalendar";
import { FaBullseye } from "react-icons/fa";
import { ContactCard, EContactCardLayout, ECardIconsLayout } from "../Contact";

export const RentalLayoutAlt: React.FC<IListingLayoutProps> = ({
  listing,
  title,
  linkFunc,
  similar,
  agents,
  className = "",
  similarCardProps,
  similarCarouselProps,
  galleryProps,
  rentalVitalsProps,
  carouselProps,
  calendarProps,
  detailsProps,
  vitalsProps,
  contactProps,
  formProps,
  summaryProps,
  mapProps,
  rowClassName = "",
  showContactUsForm,
  contactUsFormProps,
}) => {

  const rentalVitalBtnOnClick = function (props: any) {
    if (props.className?.search("view-rates-button") >= 0) {
      document.querySelector('.rates-container')?.scrollIntoView();
    }
    else if (props.className?.search("request-info-button") >= 0) {
      document.querySelector('.request-info-form')?.scrollIntoView();
      document.querySelector('.request-info-form #firstname')?.focus();
    }
  }
  const rentalVitalsLinkFunc = function (props: any) {
    return (
      <a {...props}
        onClick={() => rentalVitalBtnOnClick(props)}
      />
    )
  }

  return (
    <div className={`${className} listing-layout rental-layout-single-column`}>
      <ListingGallery
        listing={listing}
        preset={EWsrvTransform.cover3x2}
        width={1200}
        height={800}
        className="mb-3"
        {...galleryProps}
      />
      <RentalVitals
        listing={listing}
        locationIcon={false}
        composite={false}
        className="inverted mb-5 max-w-screen-xl mx-auto"
        ratesInline={true}
        rateInterval={ERateInterval.week}
        linkFunc={rentalVitalsLinkFunc}
        {...rentalVitalsProps}
      />
      <div className={`${rowClassName}`}>
        <div className="mb-3">
          {title && <h1>{title}</h1>}
          <ListingSummary listing={listing} {...summaryProps} />
        </div>
      </div>
      {listing.location && listing.location?.lat && listing.location.lng && (
        <ListingMap listing={listing} title="Location" {...mapProps} />
      )}
      <div className={`flex flex-wrap md:flex-nowrap mb-3 inverted request-info-form`}>
        {listing.agent && listing.agent.length > 0 ? (
          <ContactCard
            contact={listing.agent[0]}
            layout={EContactCardLayout.threeColsAndForm}
            contactInfoItemsLayout={ECardIconsLayout.vertical}
            className="w-full inverted"
            formTitle="REQUEST INFORMATION"
            showVCard={false}
            showAddress={true}
            iconAccent={false}
            showOffices={true}
            offices={listing.office}
            formProps={formProps}
          />
        ) : (
          <ContactForm
            classNames="strictTwoColumn mx-auto"
            {...formProps}
          />
        )}
      </div>
      <div className="max-w-screen-xl mx-auto mb-10 rates-container">
        <RentalCalendar
          listing={listing}
          title="Rates & Availability"
          {...calendarProps}
        />
        {listing.cleaningFee && <p className="block italic text-xs mt-0 mb-0.5 cleaning-fee"><span className="font-bold">Cleaning fee:</span>&nbsp;{listing.cleaningFee}</p>}
        {listing.damageSecurityDeposit && <p className="block italic text-xs mt-0 mb-0.5 security-deposit"><span className="font-bold">Security deposit:</span>&nbsp;{listing.damageSecurityDeposit}</p>}
        {listing.winterComments && <p className="block italic text-xs mt-0 mb-0.5 winter-comments"><span className="font-bold">Available for Winter Season:</span>&nbsp;{listing.winterComments}</p>}
        {listing.ownerPolicies && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Owner policies:</span>&nbsp;{listing.ownerPolicies}</p>}
        {listing.checkInTime && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Check In Time:</span>&nbsp;{listing.checkInTime}</p>}
        {listing.checkOutTime && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Check Out Time:</span>&nbsp;{listing.checkOutTime}</p>}
        {listing.additionalLodgingFees && <p className="block italic text-xs mt-0 mb-0.5 owner-policies"><span className="font-bold">Additional Lodging Fees:</span>&nbsp;{listing.additionalLodgingFees}</p>}
      </div>
      {listing.details && listing.details.length > 0 && (
        <ListingDetails
          detailGroups={listing.details}
          className="py-3"
          {...detailsProps}
        />
      )}
      {showContactUsForm && <ContactForm {...contactUsFormProps} />}
    </div>
  );
};
